"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WishListComponent = void 0;
var CustomEventTarget_1 = require("../../helpers/CustomEventTarget");
var WishListStore_1 = require("./WishListStore");
var WishlistCounter_1 = require("./WishlistCounter");
var WishlistButton_1 = require("./WishlistButton");
var dom_interact_1 = require("../../helpers/dom-interact");
var Types_1 = require("../../Modules/Types");
var ApiEndpoints_1 = require("../../Configurations/ApiEndpoints");
var tracker_1 = __importDefault(require("../../helpers/tracker"));
var Sentry_1 = require("../../helpers/Sentry");
var TrackingTypes_1 = require("../../helpers/TrackingTypes");
var EnhanceEcommerce_1 = require("../../helpers/EnhanceEcommerce");
var GA4EcommerceTracker_1 = require("./../GA4/GA4EcommerceTracker");
var WishListComponent = /** @class */ (function (_super) {
    __extends(WishListComponent, _super);
    function WishListComponent(options) {
        var _this = _super.call(this) || this;
        _this.store = new WishListStore_1.WishListStore();
        _this.counter = new WishlistCounter_1.WishlistCounter();
        _this.trackingCategory = options.trackingCategory;
        _this.buttonsList = new Map();
        _this.attachEvents();
        return _this;
    }
    WishListComponent.prototype.attachEvents = function () {
        var _this = this;
        this.store.addEventListener(Types_1.WishListEvents.STORE_ITEMS_LOADED, function () {
            _this.updateCounter();
            _this.updateButtons();
        });
        this.store.addEventListener(Types_1.WishListEvents.STORE_ADD_SUCCESS, function () {
            _this.hideLoaded();
            _this.onFinishAddToWishList();
        });
        this.store.addEventListener(Types_1.WishListEvents.STORE_ADD_ERROR, function () {
            _this.hideLoaded();
            _this.onActionFinishPopup(Types_1.WishListTemplateIds.ADD_TO_WISHLIST_ERROR);
        });
        this.store.addEventListener(Types_1.WishListEvents.STORE_DELETE_SUCCESS, function (event, isItemConfigured) {
            _this.hideLoaded();
            if (isItemConfigured) {
                _this.onActionFinishPopup(Types_1.WishListTemplateIds.DELETE_SUCCESS);
            }
        });
        this.store.addEventListener(Types_1.WishListEvents.STORE_DELETE_ERROR, function () {
            _this.hideLoaded();
            _this.onActionFinishPopup(Types_1.WishListTemplateIds.DELETE_ERROR);
        });
    };
    WishListComponent.prototype.updateCounter = function () {
        var amountOfWishListItems = this.store.getAmountOfWishListItems() || '';
        this.counter.update(amountOfWishListItems);
        if (typeof loadDataFoldout !== 'undefined') {
            loadDataFoldout(jQuery('#wishlist_overlay'));
        }
    };
    WishListComponent.prototype.updateButtons = function () {
        var _this = this;
        this.buttonsList.forEach(function (button) { return _this.updateButtonById(button.buttonId); });
    };
    WishListComponent.prototype.updateButtonById = function (id) {
        var button = this.buttonsList.get(id);
        if (!button) {
            Sentry_1.SentryLogger.getInstance().sendInfoReport({
                message: "There is no button in the buttonList on page ".concat(this.trackingCategory),
            });
            return;
        }
        var isActive = this.store.isItemInWishList(button.state);
        button.updateVisualState(isActive);
    };
    WishListComponent.prototype.getWishListButton = function (options) {
        var button = this.buttonsList.get(options.elementsList[0]);
        if (button) {
            return button;
        }
        return this.createWishListButton(options);
    };
    WishListComponent.prototype.createWishListButton = function (options) {
        var id = options.elementsList[0];
        var wishListButton = new WishlistButton_1.WishlistButton(__assign(__assign({}, options), {
            buttonId: id,
        }));
        this.buttonsList.set(id, wishListButton);
        this.updateButtonById(id);
        this.attachButtonEvents(wishListButton);
        return wishListButton;
    };
    WishListComponent.prototype.attachButtonEvents = function (button) {
        var _this = this;
        button.addEventListener(Types_1.WishListEvents.BUTTON_STATE_CHANGE, function (event, buttonId) {
            _this.updateButtonById(buttonId);
        });
        button.addEventListener(Types_1.WishListEvents.BUTTON_CLICK, function (event, payload) {
            _this.onButtonAction(payload);
        });
    };
    WishListComponent.prototype.onButtonAction = function (payload) {
        var isActive = payload.isActive, state = payload.state, passThroughParameters = payload.passThroughParameters, productJSON = payload.productJSON;
        if (isActive) {
            this.onDeleteFromWishList(state);
        }
        else {
            this.addToWishList(__assign(__assign({}, state), passThroughParameters), productJSON);
        }
    };
    WishListComponent.prototype.addToWishList = function (wishListButtonState, productJSON) {
        this.showLoaded();
        this.store.addToWishListRequest(wishListButtonState);
        tracker_1.default.track({
            category: this.trackingCategory,
            action: TrackingTypes_1.TrackingData.ACTION_ADD_TO_WISHLIST,
            label: wishListButtonState.product,
        });
        var item = EnhanceEcommerce_1.EnhanceEcommerce.buildGA4Item(productJSON, 1, 'wishlist', 'wishlist', {
            format: wishListButtonState.format,
        });
        GA4EcommerceTracker_1.GA4EcommerceTracker.trackAddToWishlist([item]);
    };
    WishListComponent.prototype.onFinishAddToWishList = function () {
        var popupTemplate = this.getAddToWishListPopupTemplate();
        this.openPopup(popupTemplate);
    };
    WishListComponent.prototype.getAddToWishListPopupTemplate = function () {
        var _this = this;
        var contentTemplate = JSON.parse((0, dom_interact_1.getHTMLElement)(document, Types_1.WishListTemplateIds.ADD_TO_WISHLIST_SUCCESS).innerHTML);
        var overlayAndCloseButtonTemplate = this.getOverlayAndCloseButtonTemplate();
        var defaultBtn = contentTemplate.find(function (template) { return !!(template.type && template.type === Types_1.MessagePopupElementTypes.DEFAULT_BUTTON); });
        var secondaryBtn = contentTemplate.find(function (template) { return !!(template.type && template.type === Types_1.MessagePopupElementTypes.SECONDARY_BUTTON); });
        if (defaultBtn) {
            defaultBtn.handler = function () { return _this.closePopup(); };
        }
        if (secondaryBtn) {
            secondaryBtn.handler = function () { return _this.goToWishList(); };
        }
        return __spreadArray(__spreadArray([], overlayAndCloseButtonTemplate, true), contentTemplate, true);
    };
    WishListComponent.prototype.onDeleteFromWishList = function (buttonStage) {
        var allItemMatches = this.store.getAllItemMatches(buttonStage);
        var isItemConfigured = this.store.isItemConfigured(allItemMatches);
        var idsList = this.store.getItemsIds(allItemMatches);
        if (!isItemConfigured) {
            this.showLoaded();
            this.deleteFromWishList(idsList, isItemConfigured);
        }
        else if (allItemMatches.length === 1 && isItemConfigured) {
            this.handleDeleteConfiguredItem(idsList, isItemConfigured, Types_1.WishListTemplateIds.DELETE_ONE_ITEM_IS_CONFIGURED);
        }
        else {
            this.handleDeleteConfiguredItem(idsList, isItemConfigured, Types_1.WishListTemplateIds.DELETE_ONE_OF_MANY_ITEM_IS_CONFIGURED);
        }
    };
    WishListComponent.prototype.deleteFromWishList = function (idsList, isItemConfigured) {
        this.dispatchEvent(new CustomEvent(Types_1.WishListEvents.POPUP_DISABLE));
        this.store.deleteFromWishListRequest(idsList, isItemConfigured);
        tracker_1.default.track({
            category: this.trackingCategory,
            action: TrackingTypes_1.TrackingData.ACTION_REMOVE_FROM_WISHLIST,
            label: idsList.length,
        });
    };
    WishListComponent.prototype.handleDeleteConfiguredItem = function (idsList, isItemConfigured, templateId) {
        var popupTemplate = this.getDeleteConfiguredItemPopupTemplate(idsList, isItemConfigured, templateId);
        this.openPopup(popupTemplate);
    };
    WishListComponent.prototype.getDeleteConfiguredItemPopupTemplate = function (idsList, isItemConfigured, templateId) {
        var _this = this;
        var contentTemplate = JSON.parse((0, dom_interact_1.getHTMLElement)(document, templateId).innerHTML);
        var overlayAndCloseButtonTemplate = this.getOverlayAndCloseButtonTemplate();
        var defaultBtn = contentTemplate.find(function (template) { return !!(template.type && template.type === Types_1.MessagePopupElementTypes.DEFAULT_BUTTON); });
        var secondaryBtn = contentTemplate.find(function (template) { return !!(template.type && template.type === Types_1.MessagePopupElementTypes.SECONDARY_BUTTON); });
        if (defaultBtn) {
            defaultBtn.handler = function () { return _this.deleteFromWishList(idsList, isItemConfigured); };
        }
        if (secondaryBtn) {
            secondaryBtn.handler = function () { return _this.goToWishList(); };
        }
        return __spreadArray(__spreadArray([], overlayAndCloseButtonTemplate, true), contentTemplate, true);
    };
    WishListComponent.prototype.onActionFinishPopup = function (templateId) {
        var popupTemplate = this.getFinishDeletePopupPopupTemplate(templateId);
        this.openPopup(popupTemplate);
    };
    WishListComponent.prototype.getFinishDeletePopupPopupTemplate = function (templateId) {
        var _this = this;
        var contentTemplate = JSON.parse((0, dom_interact_1.getHTMLElement)(document, templateId).innerHTML);
        var overlayAndCloseButtonTemplate = this.getOverlayAndCloseButtonTemplate();
        var defaultBtn = contentTemplate.find(function (template) { return !!(template.type && template.type === Types_1.MessagePopupElementTypes.DEFAULT_BUTTON); });
        if (defaultBtn) {
            defaultBtn.handler = function () { return _this.closePopup(); };
        }
        return __spreadArray(__spreadArray([], overlayAndCloseButtonTemplate, true), contentTemplate, true);
    };
    WishListComponent.prototype.getOverlayAndCloseButtonTemplate = function () {
        var _this = this;
        return [
            {
                id: Types_1.MessagePopupElementIds.OVERLAY,
                handler: function () { return _this.closePopup(); },
            },
            {
                id: Types_1.MessagePopupElementIds.CLOSE_BUTTON,
                handler: function () { return _this.closePopup(); },
            },
        ];
    };
    WishListComponent.prototype.openPopup = function (popupTemplate) {
        this.dispatchEvent(new CustomEvent(Types_1.WishListEvents.POPUP_OPEN), popupTemplate);
    };
    WishListComponent.prototype.closePopup = function () {
        this.dispatchEvent(new CustomEvent(Types_1.WishListEvents.POPUP_CLOSE));
    };
    WishListComponent.prototype.showLoaded = function () {
        this.dispatchEvent(new CustomEvent(Types_1.WishListEvents.REQUEST_START));
    };
    WishListComponent.prototype.hideLoaded = function () {
        this.dispatchEvent(new CustomEvent(Types_1.WishListEvents.REQUEST_END));
    };
    WishListComponent.prototype.goToWishList = function () {
        (0, dom_interact_1.navigate)(ApiEndpoints_1.ApiEndpoints.WISHLIST);
    };
    WishListComponent.prototype.clearButtonList = function () {
        this.buttonsList.clear();
    };
    return WishListComponent;
}(CustomEventTarget_1.CustomEventTarget));
exports.WishListComponent = WishListComponent;
